<div class="input-group typeahead typeahead-representante" [class.with-addon-left]="withAddonLeft">
    <ng-template #typeaheadTemplate let-representante="item">
        <span>{{representante.pessoa.codigoIntegracaoErp}} - {{representante.pessoa.nome}}</span>
        <small class="typeahead-cliente-cnpj-cpf">{{representante.pessoa.nomeFantasia}} - {{representante.pessoa.cnpjCpf}}</small>
        <span class="badge badge-danger badge-inativo" *ngIf="isInativo(representante.situacao)">Inativo</span>
    </ng-template>

    <div class="input-group-prepend left" *ngIf="withAddonLeft">
        <span class="input-group-text">Representante</span>
    </div>
    <div class="input-group-prepend">
        <span class="input-group-text">{{entity?.pessoa?.codigoIntegracaoErp}}</span>
    </div>    
    <input
        type="text"
        class="form-control"
        #inputTypeahead

        [typeahead]="typeaheadDataSource"
        [typeaheadWaitMs]="300"
        [typeaheadItemTemplate]="typeaheadTemplate"
        typeaheadOptionField="pessoa.nome"
        [typeaheadMinLength]="2"
        [typeaheadOptionsLimit]="typeaheadOptionsLimit"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
        [container]="container"
        [ngModel]="typeaheadSelected"
        (ngModelChange)="typeaheadToken = $event"
        (typeaheadOnSelect)="onSelectEntity($event)"
        (typeaheadNoResults)="onChangeTypeaheadNoResults($event)"
        (typeaheadLoading)="isLoading = $event"
        [dropup]="dropup"

        (keyup)="onKeyup($event)"
        (blur)="onBlur()"
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        autocomplete="off"
        placeholder="Digite para pesquisar...">

    <span *ngIf="isLoading">
        <i class="fas fa-spinner fa-pulse loading-indicator"></i>
    </span>

    <div class="input-group-append" *ngIf="!disabled">
        <button type="button" class="btn btn-light" (click)="search()" [disabled]="disabled" tabindex="-1">
            <i class="fas fa-search" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-light" (click)="clear()" [disabled]="disabled" tabindex="-1">
            <i class="fas fa-eraser" aria-hidden="true"></i>
        </button>
    </div>
</div>
<p class="form-text text-muted nome-fantasia-cnpj-cpf" *ngIf="entity && entity.pessoa">
    {{entity.pessoa.nomeFantasia}} - {{entity.pessoa.cnpjCpf}}
    <span class="badge badge-danger badge-inativo" *ngIf="isInativo(entity.situacao)">Inativo</span>
</p>
<p class="form-text text-muted" *ngIf="typeaheadNoResults === true">Nenhum representante foi encontrado</p>

<!-- Modal de pesquisa -->
<sgt-representante-filter-modal
    idModal="representanteFilterModal"
    [situacao]="situacao"
    (selectEntity)="onSelectEntityModal($event)"
    #representanteFilterModal>
</sgt-representante-filter-modal>
